import { useState, useEffect, useRef, useCallback } from 'react';
export const useHover = <T extends HTMLElement = HTMLDivElement,>(options?: {
  disableTap?: boolean;
  disabled?: boolean;
}) => {
  const [hovered, setHovered] = useState(false);
  const ref = useRef<T>(null);
  const onStart = useCallback(() => setHovered(true), []);
  const onEnd = useCallback(() => setHovered(false), []);
  const {
    disableTap,
    disabled
  } = options ?? {};
  useEffect(() => {
    if (ref.current) {
      const c = ref.current;
      if (disabled) return;
      c.addEventListener('mouseleave', onEnd, {
        passive: true
      });
      c.addEventListener('mouseenter', onStart, {
        passive: true
      });
      if (!disableTap) {
        c.addEventListener('touchstart', onStart, {
          passive: true
        });
        c.addEventListener('touchend', onEnd, {
          passive: true
        });
      }
      return () => {
        c?.removeEventListener('mouseenter', onStart);
        c?.removeEventListener('mouseleave', onEnd);
        if (!disableTap) {
          c?.removeEventListener('touchstart', onStart);
          c?.removeEventListener('touchend', onEnd);
        }
      };
    }
  }, [disableTap, ref.current, disabled]);
  return {
    ref,
    hovered
  };
};